import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Link from 'gatsby-link';
import ReactPlayer from 'react-player';
import SearchInput, { createFilter } from '../components/ReactSearchInput';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import List from 'react-virtualized/dist/commonjs/List';

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

import _ from 'lodash';
import * as Scroll from 'react-scroll';

import TelegramIcom from './telegram.svg';
import Track from '../components/Track/Track';
import Alert from '../components/Alert/Alert';
import Duration from '../components/Duration/Duration';

const Element = Scroll.Element;
const scroll = Scroll.scroller;

const KEYS_TO_FILTERS = [
  'node.Title',
  'node.Username',
  'node.id',
  'node.Filter'
];

class IndexPage extends Component {
  constructor(props) {
    super(props);

    const tracks = this.props.data.allAirtable.edges;
    const reversedTracks = [...tracks].reverse();

    this.searchUpdated = this.searchUpdated.bind(this);

    this.state = {
      currentTrackNumber: 0,
      currentTrackURL: false,
      currentTrackID: reversedTracks[0].node.id,
      tracks: false,
      pageTitle: 'Line.fm',
      seeking: false,
      duration: 0,
      playing: true,
      played: 0,
      playedSeconds: 0,
      loaded: 0,
      loadedSeconds: 0,
      volume: 1,
      muted: false,
      reversedTracks: reversedTracks,
      storage: '',
      randomToggle: false,
      randomToggleState: false,
      featuredToggle: false,
      featuredToggleState: false,
      searchToggle: false,
      searchTerm: '',
      hideVideo: false,
      metaDescription: 'Listen to all tunes from @wipmusic.',
      metaImage: '',
      directTrackURL: false
    };
  }
  _scrollTo(trackNumber) {
    scroll.scrollTo(`track-${trackNumber}`, {
      duration: 750,
      delay: 100,
      smooth: true,
      offset: -74,
      containerId: 'scrollable'
    });
  }
  componentDidMount() {
    const tracks = this.props.data.allAirtable.edges;
    const reversedData = [...tracks].reverse();
    const storage = window.localStorage.getItem('linefm-played');
    const randomSettings = window.localStorage.getItem('linefm-random');

    if (!storage) {
      window.localStorage.setItem('linefm-played', 'none');
    }

    if (!randomSettings) {
      window.localStorage.setItem('linefm-random', 'off');
    }

    this.setState({
      currentTrackURL: reversedData[0].node.Link,
      tracks: tracks.length,
      storage: window.localStorage.getItem('linefm-played'),
      randomToggle: window.localStorage.getItem('linefm-random'),
      featuredToggle: window.localStorage.getItem('linefm-featured')
    });

    if (window.localStorage.getItem('linefm-random') === 'on') {
      this.setState({
        randomToggleState: true
      });
    }

    if (window.localStorage.getItem('linefm-featured') === 'on') {
      this.setState({
        featuredToggleState: true,
        searchTerm: 'Featured',
        playing: false
      });

      setTimeout(() => {
        const nextTrack = window.document.querySelector(
          `[data-track-number="0"] li`
        );

        setTimeout(() => {
          nextTrack.click();

          this.setState({
            playing: true
          });
        }, 350);
      }, 500);
    }

    if (window.location.search) {
      const trackID = window.location.search.replace('?play=', '');

      this.setState({
        playing: false,
        searchTerm: trackID,
        directTrackURL: true
      });

      setTimeout(() => {
        const nextTrack = window.document.querySelector(
          `[data-track-id="${trackID}"] li`
        );

        setTimeout(() => {
          nextTrack.click();

          this.setState({
            playing: true,
            metaDescription: window.document.querySelectorAll('li h2')[0]
              .innerHTML,
            metaImage: window.document.querySelectorAll('li img')[0].src
          });
        }, 350);
      }, 500);

      setTimeout(() => {
        this.setState({
          searchTerm: ''
        });
        history.pushState(null, '', location.href.split('?')[0]);
      }, 10000);
    }
  }
  onDuration = duration => {
    this.setState({ duration });
  };
  onSeekMouseDown = e => {
    this.setState({ seeking: true });
  };
  onSeekChange = e => {
    this.setState({ played: parseFloat(e.target.value) });
  };
  onSeekMouseUp = e => {
    this.setState({ seeking: false });
    this.player.seekTo(parseFloat(e.target.value));
  };
  onProgress = state => {
    // We only want to update time slider if we are not currently seeking
    if (!this.state.seeking) {
      this.setState(state);
    }
  };
  playPause = () => {
    this.setState({ playing: !this.state.playing });
  };
  setVolume = e => {
    this.setState({ volume: parseFloat(e.target.value) });
  };
  toggleMuted = () => {
    this.setState({ muted: !this.state.muted });
  };
  changeTrack(track) {
    this.setState({
      currentTrackURL: track
    });
  }
  setTrackNameTitle() {
    const trackName = window.document.querySelector(
      `[name="track-${this.state.currentTrackNumber}"] h2`
    ).innerHTML;

    this.setState({
      pageTitle: _.unescape(trackName)
    });

    setInterval(() => {
      document.title = this.state.pageTitle;
    }, 150);
  }
  restoreTitle() {
    this.setState({
      pageTitle: 'Line.fm 𝘾𝙡𝙖𝙨𝙨𝙞𝙘'
    });
  }
  playNext() {
    let storage = window.localStorage.getItem('linefm-played');
    const newID = [this.state.currentTrackID];
    window.localStorage.setItem('linefm-played', [storage, ...newID]);

    setTimeout(() => {
      if (
        (this.state.loaded === 1 && this.state.played === 1) ||
        this.state.played === this.state.playedSeconds ||
        (this.state.played === 1 &&
          this.state.playedSeconds === this.state.duration)
      ) {
        if (this.state.randomToggleState) {
          this.randomTrack();
        } else {
          this.upcomingTrack();
        }
      }
    }, 3000);
  }
  upcomingTrack() {
    this.restoreTitle();

    const nextTrack = window.document.querySelector(
      `[name="track-${this.state.currentTrackNumber + 1}"] li`
    );

    this.setState({
      storage: window.localStorage.getItem('linefm-played'),
      played: 0
    });

    nextTrack.click();
    this._scrollTo(this.state.currentTrackNumber);
  }
  randomTrack() {
    this.restoreTitle();

    const total =
      parseInt(
        window.document.querySelector('#filteredTracksCount').innerHTML
      ) - 1;
    const randomNumber = Math.floor(Math.random() * (total - 0 + 1)) + 0;

    this.setState({
      currentTrackNumber: randomNumber,
      played: 0
    });

    setTimeout(() => {
      const nextTrack = window.document.querySelector(
        `[name="track-${randomNumber}"] li`
      );

      nextTrack.click();
      this._scrollTo(randomNumber);
    }, 500);
  }
  ref = player => {
    this.player = player;
  };
  handleRandomToggleChange() {
    this.setState({
      randomToggleState: !this.state.randomToggleState
    });

    if (!this.state.randomToggleState) {
      window.localStorage.setItem('linefm-random', 'on');
    }

    if (this.state.randomToggleState) {
      window.localStorage.setItem('linefm-random', 'off');
    }
  }
  toggleFeatured() {
    this.setState({
      featuredToggleState: !this.state.featuredToggleState
    });

    if (!this.state.featuredToggleState) {
      window.localStorage.setItem('linefm-featured', 'on');
      this.setState({
        searchTerm: 'Featured'
      });
    }

    if (this.state.featuredToggleState) {
      window.localStorage.setItem('linefm-featured', 'off');
      this.setState({
        searchTerm: '',
        playing: false
      });
    }
  }
  displaySearchBox() {
    this.setState({
      searchToggle: !this.state.searchToggle
    });
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  clearSearchTerm() {
    this.setState({
      searchTerm: ''
    });
  }
  hideVideo() {
    this.setState({
      hideVideo: !this.state.hideVideo
    });
  }
  render() {
    let storage = this.state.storage;
    const filteredTracks = this.state.reversedTracks.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    );

    return (
      <div>
        <Alert
          message={`
            The site is in read-only mode and the Telegram bot has been paused while a new <strong>Line.fm</strong> is being made. Thanks for taking part in this experiment! Enjoy all the music we have gathered.

            Follow <a href="https://twitter.com/pugson" target="_blank">@pugson</a> or <a href="https://twitter.com/linedotfm" target="_blank">@linedotfm</a> for updates.
          `}
          alertID="linefm-v1-paused"
        />
        <Sidebar>
          <SidebarInner id="scrollable">
            <SidebarControls>
              <div className="center-sidebar-wrapper">
                <h1>
                  WIP Music
                  <Tooltip
                    html={
                      <TooltipContent>
                        <TooltipHeader>Play a random track</TooltipHeader>
                        <label data-checked={this.state.randomToggleState}>
                          Next track always random
                          <input
                            id="random"
                            type="checkbox"
                            value={this.state.randomToggleState}
                            onChange={this.handleRandomToggleChange.bind(this)}
                          />
                        </label>
                      </TooltipContent>
                    }
                    position="bottom"
                    trigger="mouseenter"
                    inertia
                    interactive
                    size="small"
                  >
                    <RandomButton
                      onClick={this.randomTrack.bind(this)}
                      className={
                        this.state.randomToggleState ? 'random-enabled' : null
                      }
                    >
                      {iconRandom}
                    </RandomButton>
                  </Tooltip>
                  <Tooltip
                    title="Play only featured tunes"
                    position="bottom"
                    trigger="mouseenter"
                    inertia
                    size="small"
                  >
                    <RandomButton
                      onClick={this.toggleFeatured.bind(this)}
                      className={
                        this.state.featuredToggleState
                          ? 'featured-enabled'
                          : null
                      }
                    >
                      {iconStar}
                    </RandomButton>
                  </Tooltip>
                  <RandomButton
                    className={
                      this.state.searchToggle
                        ? 'searchButton search-enabled'
                        : 'searchButton'
                    }
                    data-filtering={this.state.searchTerm ? 'yes' : null}
                    onClick={this.displaySearchBox.bind(this)}
                  >
                    {iconSearch}
                  </RandomButton>
                  <Tooltip
                    title="Hide the video player"
                    position="bottom"
                    trigger="mouseenter"
                    inertia
                    size="small"
                  >
                    <RandomButton
                      className={
                        this.state.hideVideo
                          ? 'hideVideoButton hidden-enabled'
                          : 'hideVideoButton'
                      }
                      onClick={this.hideVideo.bind(this)}
                    >
                      {iconVisibility}
                    </RandomButton>
                  </Tooltip>
                  <TracksCount>
                    <span id="filteredTracksCount">
                      {filteredTracks.length}
                    </span>{' '}
                    tracks
                  </TracksCount>
                </h1>
              </div>
              {this.state.searchToggle && (
                <SearchWrapper>
                  <SearchInput
                    className={
                      this.state.searchTerm
                        ? 'search-enabled search-input'
                        : 'search-input'
                    }
                    value={this.state.searchTerm}
                    autoFocus
                    onChange={this.searchUpdated}
                    placeholder="Search or filter tunes..."
                  />
                  <ClearSearchButton onClick={this.clearSearchTerm.bind(this)}>
                    Clear
                  </ClearSearchButton>
                </SearchWrapper>
              )}
            </SidebarControls>
            <AutoSizer>
              {({ height, width }) => (
                <List
                  className="playlist"
                  width={width}
                  height={height}
                  scrollToIndex={this.state.currentTrackNumber}
                  scrollToAlignment="start"
                  rowHeight={184}
                  rowCount={filteredTracks.length}
                  rowRenderer={({ index, key, style }) => (
                    <Element
                      name={`track-${index}`}
                      key={filteredTracks[index].node.id}
                      data-track-number={index}
                      style={style}
                      className="playlist-track-item"
                      data-track-id={filteredTracks[index].node.id.replace(
                        'Airtable WIP Music ',
                        ''
                      )}
                    >
                      <li
                        onClick={e => {
                          this.changeTrack(filteredTracks[index].node.Link);
                          this.setState({
                            currentTrackNumber: index,
                            currentTrackID: filteredTracks[index].node.id
                          });
                        }}
                      >
                        <Track
                          number={index}
                          link={filteredTracks[index].node.Link}
                          user={filteredTracks[index].node.Username}
                          image={filteredTracks[index].node.Image}
                          logo={filteredTracks[index].node.Logo}
                          title={filteredTracks[index].node.Title}
                          date={filteredTracks[index].node.Date}
                          featured={filteredTracks[index].node.Featured}
                          played={
                            storage.match(filteredTracks[index].node.id)
                              ? 'played'
                              : 'fresh'
                          }
                          playing={
                            this.state.currentTrackNumber === index
                              ? true
                              : false
                          }
                          activelyPlaying={this.state.playing}
                          id={filteredTracks[index].node.id.replace(
                            'Airtable WIP Music ',
                            ''
                          )}
                        />
                      </li>
                    </Element>
                  )}
                />
              )}
            </AutoSizer>
          </SidebarInner>
        </Sidebar>
        <PlayerArea
          className={this.state.hideVideo ? 'hide-video-player' : null}
        >
          {this.state.currentTrackURL && (
            <ReactPlayer
              ref={this.ref}
              url={this.state.currentTrackURL}
              playing={this.state.playing}
              playsInline
              volume={this.state.volume}
              muted={this.state.muted}
              preload={true}
              width="100%"
              height="100%"
              onSeek={e => console.log('onSeek', e)}
              onDuration={this.onDuration}
              onProgress={this.onProgress}
              onPlay={this.setTrackNameTitle.bind(this)}
              onPause={this.restoreTitle.bind(this)}
              onEnded={this.playNext.bind(this)}
            />
          )}
          {this.state.hideVideo && (
            <div className="hidden-video-state">
              {iconVisibility}
              <h2>Video hidden</h2>
              <p>Enjoy the sounds without visual distractions</p>
            </div>
          )}
        </PlayerArea>
        <ControlsArea>
          <ControlButton
            id="bs-play-pause"
            onClick={this.playPause.bind(this)}
            className={this.state.playing ? 'bs-playing' : 'bs-paused'}
          >
            {this.state.playing && pauseIcon}
            {!this.state.playing && playIcon}
          </ControlButton>
          <ControlButton
            id="bs-next-track"
            onClick={this.upcomingTrack.bind(this)}
          >
            {nextIcon}
          </ControlButton>
          <TrackProgress>
            <Duration seconds={this.state.duration * this.state.played} />
            <RangeProgress className="inputProgress">
              <div className="progressTrack">
                <progress max={1} value={this.state.played} />
              </div>
              <input
                type="range"
                min={0}
                max={1}
                step="any"
                value={this.state.played}
                onMouseDown={this.onSeekMouseDown}
                onChange={this.onSeekChange}
                onMouseUp={this.onSeekMouseUp}
              />
            </RangeProgress>
            <Duration seconds={this.state.duration} />
          </TrackProgress>
          <ControlButton className="muteButton" onClick={this.toggleMuted}>
            {this.state.muted ? volumeMuted : volumePlaying}
          </ControlButton>
          <RangeProgress className="inputVolume" data-muted={this.state.muted}>
            <div className="progressTrack">
              <progress max={1} value={this.state.volume} />
            </div>
            <input
              type="range"
              min={0}
              max={1}
              step="any"
              value={this.state.volume}
              onChange={this.setVolume}
            />
          </RangeProgress>
        </ControlsArea>
        {/* <Helmet defer={false}>
          <title>{this.state.pageTitle}</title>
        </Helmet> */}
        {this.state.directTrackURL ? (
          <Helmet>
            <meta property="og:title" content={this.state.pageTitle} />
            <meta
              property="og:description"
              content={this.state.metaDescription}
            />
            <meta property="og:type" content="music.song" />
            <meta property="og:image" content={this.state.metaImage} />
            <meta name="twitter:card" content="summary_large_image" />
          </Helmet>
        ) : (
          <Helmet>
            <title>Line.fm 𝘾𝙡𝙖𝙨𝙨𝙞𝙘</title>
            <meta property="og:url" content="https://classic.line.fm" />
            <meta
              property="og:image"
              content="https://classic.line.fm/static/Favicon@4x.png"
            />
            <meta property="og:title" content="Line.fm 𝘾𝙡𝙖𝙨𝙨𝙞𝙘" />
            <meta
              property="og:description"
              content="Good tunes on autopilot 🎵✈️😎. Listen to all tunes from @wipmusic. (RIP)"
            />
            <meta name="twitter:card" content="summary" />
          </Helmet>
        )}
      </div>
    );
  }
}

export default IndexPage;

export const query = graphql`
  query Tracks {
    allAirtable {
      edges {
        node {
          id
          Link
          Username
          Date
          Title
          Image
          Logo
          Featured
          Filter
        }
      }
    }
  }
`;

const Sidebar = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  background-color: #121212;
  width: 420px;
  padding: 0;
  @media (max-width: 700px) {
    width: 100%;
    height: calc(100vh - 212px);
    top: 212px;
  }
  @media (pointer: fine) and (max-height: 520px) and (max-width: 900px) {
    top: 0;
    height: 100vh;
    width: 420px;
  }

  h1 {
    display: flex;
    align-items: center;
    width: 100%;
    line-height: 1;
    font-size: 1rem;
    margin: 0;
    padding: 0 1rem;
    padding-top: 0.7rem;
    padding-bottom: 0.025em;
    position: sticky;
    top: 0.5rem;
    left: 0;
    z-index: 999;
    text-shadow: 0 2px 15px rgba(0, 0, 0, 0.85);
    ${'' /* outline: 1px solid rgba(255, 0, 0, 0.75); */};
  }

  .playlist {
    padding: 4px;
    margin: 0;
    ${'' /* margin-top: 2rem; */} padding: 1rem;
    height: 100%;
    position: relative;
    display: block;
    user-select: none;
    outline: none;

    ::-webkit-scrollbar {
      display: none;
    }

    [name^='track'] {
      width: calc(100% - 8px) !important;
      transform: translateX(4px) translateY(8px);
    }

    li {
      display: block;
    }

    li,
    li > div {
      position: relative;
    }
  }

  #scrollable {
    padding-top: 3rem;
  }
`;

const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  top: 0.5rem;
  padding: 0 1rem 0.5rem;
  background-color: black;

  > div {
    width: 100%;
  }

  .search-input input {
    color: #fff;
    width: 100%;
    border: none;
    border-radius: 0.5rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    position: relative;
    ${'' /* background-color: rgba(0, 0, 0, 0.5); */} background-color: rgba(255, 255, 255, 0.12);
    outline: none;
    transition: 0.2s ease all;

    &:focus {
      box-shadow: inset 0 0 0 1px #00a8ff;
    }
  }

  .search-enabled input {
    background-color: #0097e6;
  }
`;

const SidebarControls = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 420px;
  height: 3rem;
  background-color: black;

  .center-sidebar-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const ClearSearchButton = styled.button`
  color: #666;
  font-size: 0.75rem;
  background: none;
  border: none;
  outline: none;
  width: 64px;
  transition: 0.15s ease all;
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  &:active {
    transform: scale(0.95);
  }
`;

const TelegramLink = styled.a`
  display: inline-block;
  line-height: 0;
  margin-left: 0.5rem;
  position: relative;
  top: 1px;

  img {
    width: 1.5rem;
    height: auto;
    margin: 0;
  }
`;

const SidebarInner = styled.div`
  position: relative;
  display: block;
  height: 100%;
  ${'' /* overflow: scroll; */} -webkit-overflow-scrolling: touch;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left 80%,
    left bottom,
    from(#000),
    to(rgba(0, 0, 0, 0))
  );

  ::-webkit-scrollbar {
    display: none;
  }
`;

const PlayerArea = styled.main`
  background: #000;
  height: calc(100vh - 3rem);
  position: fixed;
  right: 0;
  top: 3rem;
  width: calc(100% - 420px);
  @media (max-width: 700px) {
    width: 100%;
    height: 212px;
    top: 0;
  }
  @media (pointer: fine) and (max-height: 520px) and (max-width: 900px) {
    height: calc(100vh - 3rem);
    position: fixed;
    right: 0;
    top: 0;
    width: calc(100% - 420px);
  }

  &.hide-video-player > div:not(.hidden-video-state) {
    opacity: 0 !important;
    visibility: hidden !important;
  }

  .hidden-video-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;

    svg {
      transform: scale(3);
      margin-bottom: 2rem;
    }

    h2 {
      font-size: 1.25rem;
      margin-bottom: 0.5rem;
    }

    p {
      color: #666;
    }
  }
`;

const ControlsArea = styled.div`
  position: fixed;
  width: calc(100% - 420px);
  height: 3rem;
  top: 0;
  right: 0;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  background-color: hsla(0, 0%, 0%, 1);
`;

const ControlButton = styled.button`
  outline: 0;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  position: relative;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: 0.15s ease all;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }

  &:active {
    transform: scale(0.92);
    background-color: #00a8ff;
  }

  #playIcon {
    transform: translateX(1px);
  }

  #nextIcon {
    transform: scale(0.85);
  }

  &.muteButton {
    margin-right: 0.15rem;
    color: #444;

    svg {
      overflow: visible;
    }
  }
`;

const EndlessPromo = styled.div`
  display: block;
  position: fixed;
  bottom: 0.5rem;
  right: 0;
  padding: 0.5rem;
  padding-bottom: 0;
  z-index: 9999;

  .endless-button {
    display: block;
    text-align: center;
    text-decoration: none;
    padding: 0.5rem 1rem;
    background-color: #121212;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.14);
    color: HSLA(0, 94%, 65%, 1);
    font-size: 0.875rem;
    border-radius: 0.5rem;
  }
`;

const RangeProgress = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .progressTrack {
    position: absolute;
    display: flex;
    align-items: center;
    height: 8px;
    width: 100%;
    pointer-events: none;

    &::before {
      content: '';
      height: 6px;
      width: calc(100% - 4px);
      background-color: #444;
      position: absolute;
      ${'' /* top: 7px; */} left: 1px;
      border-radius: 10rem;
      z-index: -1;
    }

    progress {
      width: 100%;
    }
  }

  [type='range'] {
    position: relative;
    z-index: 2;
  }

  &.inputVolume {
    max-width: 4rem;
  }

  &[data-muted='true'] {
    opacity: 0.5;
  }
`;

const TrackProgress = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 1rem;

  .inputProgress {
    width: calc(100% - 6rem);
    max-width: 600px;
  }
`;

const TracksCount = styled.span`
  font-size: 0.75rem;
  font-weight: 300;
  color: #999;
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  ${'' /* background: rgba(255, 255, 255, 0.05); */} background: rgba(255, 255, 255, 0.12);
  @supports (-webkit-backdrop-filter: blur(0)) {
    background-color: rgba(255, 255, 255, 0.1);
    -webkit-backdrop-filter: blur(12px) saturate(150%) contrast(120%);
  }
  padding: 0.35rem 0.5rem;
  border-radius: 10rem;
  text-shadow: none;
`;

const RandomButton = styled.button`
  border: none;
  outline: none;
  background-color: rgba(255, 255, 255, 0.15);
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
  font-size: 0.75rem;
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 100%;
  position: relative;
  cursor: pointer;
  transform: scale(1);
  will-change: transform;
  transition: 0.15s ease all;

  &:hover {
    background-color: #27ae60;
  }

  &:active {
    transform: scale(0.9);
  }

  svg {
    width: 1em;
    height: auto;
    flex-shrink: 0;
    @media (max-width: 460px) {
      position: absolute;
      left: 0.6em;
      top: 0.45em;
      overflow: visible;
    }
  }

  &.random-enabled {
    background-color: #27ae60;
  }

  &.featured-enabled {
    background-color: #fbc02d;

    svg path {
      fill: #c75d00;
    }
  }

  &.hideVideoButton {
    font-size: 16px;
  }

  &.hidden-enabled {
    background-color: #2a27e6;
  }

  &.searchButton:hover,
  &.search-enabled,
  &[data-filtering='yes'] {
    background-color: #00a8ff;
  }
`;

const iconRandom = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path fill="currentColor" d="M16 0L10 0 16 6z" />
    <path fill="currentColor" d="M16 10L16 16 10 16z" />
    <path
      fill="currentColor"
      d="M10.828 6.586l2.879-2.879a.999.999 0 1 0-1.414-1.414L9.414 5.172l1.414 1.414zM5.172 9.414L.293 14.293a.999.999 0 1 0 1.414 1.414l4.879-4.879-1.414-1.414z"
    />
    <path
      fill="currentColor"
      d="M14 15a.997.997 0 0 1-.707-.293l-13-13A.999.999 0 1 1 1.707.293l13 13A.999.999 0 0 1 14 15z"
    />
  </svg>
);

const iconSearch = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M12.7 11.3c.9-1.2 1.4-2.6 1.4-4.2 0-3.9-3.1-7.1-7-7.1S0 3.2 0 7.1c0 3.9 3.2 7.1 7.1 7.1 1.6 0 3.1-.5 4.2-1.4l3 3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-3-3.1zm-5.6.8c-2.8 0-5.1-2.2-5.1-5S4.3 2 7.1 2s5.1 2.3 5.1 5.1-2.3 5-5.1 5z"
    />
  </svg>
);

const TooltipContent = styled.div`
  text-align: left;
  padding: 0.5rem;
  position: relative;

  label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    line-height: 1;
    cursor: pointer;

    &::before {
      content: '';
      width: 2rem;
      height: 1rem;
      background-color: #444;
      border-radius: 40em;
      margin-right: 0.5rem;
      transition: 0.2s ease all;
    }

    &::after {
      content: '';
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 100%;
      background-color: #fff;
      position: absolute;
      left: 0.25rem;
      top: 0.25rem;
      transition: 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
    }
  }

  label[data-checked='true'] {
    &::before {
      background-color: #27ae60;
    }
    &::after {
      transform: translateX(1rem);
    }
  }

  input {
    display: none;
  }
`;

const TooltipHeader = styled.h3`
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 0.75rem;
`;

const pauseIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g fill="currentColor">
      <path d="M5 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM14 1h-3c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1z" />
    </g>
  </svg>
);

const playIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" id="playIcon">
    <path
      fill="currentColor"
      d="M14 7.999a.999.999 0 0 0-.427-.819l-10-7A1 1 0 0 0 2 .999V15a.999.999 0 0 0 1.573.819l10-7A.995.995 0 0 0 14 8.001v-.002c0 .001 0 .001 0 0z"
    />
  </svg>
);

const nextIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" id="nextIcon">
    <g fill="currentColor">
      <path d="M11.6 7.2l-10-7A1 1 0 0 0 0 1v14c0 .8.9 1.3 1.6.8l10-7c.5-.4.5-1.2 0-1.6z" />
      <path
        data-color="color-2"
        d="M15 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1s1-.4 1-1V1c0-.6-.4-1-1-1z"
      />
    </g>
  </svg>
);

const volumePlaying = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path
        d="M2 8.997C2 8.447 2.443 8 3.01 8H6l6-4v16l-6-4H3.01C2.451 16 2 15.547 2 15.003V8.997z"
        strokeLinejoin="round"
      />
      <path d="M16 8s2 1.5 2 4-2 4-2 4" />
    </g>
  </svg>
);

const volumeMuted = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g
      stroke="#d32f2f"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path
        d="M2 8.997C2 8.447 2.443 8 3.01 8H6l6-4v16l-6-4H3.01C2.451 16 2 15.547 2 15.003V8.997z"
        strokeLinejoin="round"
      />
      <path d="M16 15l6-6M22.025 15L16 9" />
    </g>
  </svg>
);

const iconStar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="#fff"
      d="M15.144 5.438l-4.316-.627L8.897.9C8.559.217 7.441.217 7.103.9l-1.93 3.911-4.317.627a1.002 1.002 0 0 0-.554 1.707l3.124 3.044-.737 4.299a1 1 0 0 0 1.451 1.054L8 13.513l3.861 2.03c.728.381 1.591-.234 1.451-1.054l-.737-4.299 3.124-3.044a1.003 1.003 0 0 0-.555-1.708z"
    />
  </svg>
);

const iconVisibility = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g fill="currentColor">
      <path d="M14.6 5.6l-8.2 8.2c.5.1 1.1.2 1.6.2 3.6 0 6.4-3.1 7.6-4.9.5-.7.5-1.6 0-2.3-.2-.3-.6-.7-1-1.2zM14.3.3L11.6 3C10.5 2.4 9.3 2 8 2 4.4 2 1.6 5.1.4 6.9c-.5.7-.5 1.6 0 2.2.5.8 1.4 1.8 2.4 2.7L.3 14.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l14-14c.4-.4.4-1 0-1.4s-1-.4-1.4 0zm-9 9C5.1 8.9 5 8.5 5 8c0-1.7 1.3-3 3-3 .5 0 .9.1 1.3.3l-4 4z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/pages/index.js